import { Component, Input, ViewEncapsulation } from '@angular/core';

import { BaseModalWithProfilePhotoComponent } from '../base-modal-with-profile-photo/base-modal-with-profile-photo.component';
import { EntityTypeEnum } from 'src/app/core/enums/entity-type-id-enum';
import { BlogsBaseModel } from 'src/app/core/models/blogs/blogs-base.model';
import { Observable, Subject } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { Router } from '@angular/router';
import { SecurityOperations } from 'src/app/core/security/security-operations';
import { BlogStatus } from 'src/app/core/enums/blog-status-enum';
import { BlogListService } from 'src/app/core/services/list-services/blog-list.service';
import { NgSelectListModel } from 'src/app/core/models/ng-select-list.model';
import { AiApiService } from 'src/app/core/services/ai-api.service';
import { EntityFileUploadModel } from 'src/app/core/models/file/entity-file-upload-model';

@Component({
  selector: 'app-create-blog-modal',
  templateUrl: './create-blog-modal.component.html',
  styleUrls: ['./create-blog-modal.component.scss'],

  encapsulation: ViewEncapsulation.None,

})
export class CreateBlogModalComponent extends BaseModalWithProfilePhotoComponent {

  unsubscribe: any[] = [];
  entityTypeId = EntityTypeEnum.Blog;

  minLengthTerm: number = 1;
  searchTerm: string | undefined;
  searchTerm$ = new Subject<string>();

  isOwnerOfBlog: boolean = false;

  blogStatusOptions = [
    { value: BlogStatus.Draft, selectedText: $localize`:@@:Draft`, dropdownText: $localize`:@@:Draft` },
    { value: BlogStatus.Published, selectedText: $localize`:@@:Published`, dropdownText: $localize`:@@:Published` },
    { value: BlogStatus.Archived, selectedText: $localize`:@@:Archived`, dropdownText: $localize`:@@:Archived` }
  ]

  hasBlogCreate = this.authMyFileService.canAccessOperation(SecurityOperations.blog.blogCreate);
  hasBlogDelete = this.authMyFileService.canAccessOperation(SecurityOperations.blog.blogDelete);
  hasBlogUpdate = this.authMyFileService.canAccessOperation(SecurityOperations.blog.blogUpdate);

  categoryOptions: NgSelectListModel[] = [];
  categoryData$!: Observable<any[]>;

  @Input() public override model: BlogsBaseModel = new BlogsBaseModel;

  constructor(
    private router: Router,
    protected blogListService: BlogListService,
    protected aiApiService: AiApiService,
    protected override myFileApiService: MyfileApiService,
    protected override authMyFileService: AuthMyfileService,
    protected override modalRef: NgbActiveModal,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override sanitizer: DomSanitizer
  ) {
    super(myFileApiService, authMyFileService, modalRef, toasterNotificationService, sanitizer);
    this.categoryData$ = blogListService.categories$;
  }

  override ngOnInit(): void {
    if (this.model.id === undefined) {
      this.newModel = true;
    }
    this.searchTerm$.subscribe(search => {
      if (search != undefined) {
        this.searchTerm = search;
      }
    });


    const subscr3 = this.categoryData$.subscribe((categories: any[]) => {
      this.categoryOptions = [];
      categories.forEach(category => {
        if (category.id) {
          this.categoryOptions.push(category.name)
        }
      });
    });
    this.unsubscribe.push(subscr3);

    if (this.model.createdById === this.authMyFileService.currentUserContextValue?.id) {
      this.isOwnerOfBlog = true;
    }

    if (this.model.id) {
      this.loadProfilePhoto(this.model.id, this.entityTypeId, this.model.coverPhotoFileId, this.model.createdBy?.fullName);
    }

  }

  override validate(): boolean {
    return true;
  }

  onUpdate(): void {
    this.newModel = false;
    this.disableEditing = true;

    if (this.profileId !== undefined) {
      this.model.coverPhotoFileId = this.profileId;
      this.model.fileUpload.entityId = this.model.id;
      this.model.fileUpload.entityTypeId = EntityTypeEnum.Blog;

      if (this.model.createdBy) {
        this.model.createdByName = this.model.createdBy.fullName;
      }

      this.myFileApiService.processEntityFiles(this.model.fileUpload).subscribe((result: any) => {
        if (result.entityFileIdsAdded && result.entityFileIdsAdded[0]) {
          this.model.coverPhotoFileId = result.entityFileIdsAdded[0];
        }
        this.aiApiService.updateBlog(this.model).subscribe(result => {
          this.disableEditing = false;
          this.close();
        })
      }
      )
    } else {
      this.aiApiService.updateBlog(this.model).subscribe(result => {
        this.disableEditing = false;
        this.close();
      })
    }
  }

  onCreate(): void {
    this.newModel = false;
    this.disableEditing = true;
    if (this.model.createdBy) {
      this.model.createdByName = this.model.createdBy.fullName;
    }
    this.aiApiService.createBlog(this.model).subscribe(result => {
      if (result !== undefined) {
        this.model = result;
        if (this.profileId !== undefined) {

          if (this.model.fileUpload == undefined) {
            this.model.fileUpload = new EntityFileUploadModel();
          }

          this.model.fileUpload.entityId = this.model.id;
          this.model.fileUpload.entityTypeId = EntityTypeEnum.Blog
          this.model.fileUpload.fileIdsToAdd.push(this.profileId);

          this.myFileApiService.processEntityFiles(this.model.fileUpload).subscribe((result: any) => {
            if (result.entityFileIdsAdded && result.entityFileIdsAdded[0]) {
              this.model.coverPhotoFileId = result.entityFileIdsAdded[0];
            }
            this.aiApiService.updateBlog(this.model).subscribe(result => {
              this.router.navigateByUrl(`/pages/blogs-view?id=${this.model.id}`);
              this.disableEditing = false;
              this.close();
            })
          });

        } else {
          this.router.navigateByUrl(`/pages/blogs-view?id=${this.model.id}`);
          this.close();
        }
      }
      this.newModel = true;
      this.disableEditing = false;
    })
  }



  onDelete(): void {
    this.newModel = false;
    this.disableEditing = true;
    this.aiApiService.deleteBlog(this.model.id!).subscribe(result => {
      this.disableEditing = false;
      this.close();
    })
  }

  onPublish(): void {
    this.model.isPublic = !this.model.isPublic;
    this.aiApiService.updateBlog(this.model).subscribe(result => {
      this.disableEditing = false;
      this.close();
    })
  }

  onView(): void {
    if (this.router.routerState.snapshot.url !== `/pages/blogs-view?id=${this.model.id}`) {
      this.router.navigateByUrl(`/pages/blogs-view?id=${this.model.id}`);
    }
    this.close();
  }

  addCustomTag(tag: any) {
    return tag;
  }

  updateText(event: any) {
    this.model.blogText = event;
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }


}
